<template>
    <client-page class="wrap wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'마이페이지'"></sub-visual>
        <mypage-navigation></mypage-navigation>

        <section class="section--sm section--first">
            <v-container>
                <tit-primary
                sc="Attendance status"
                tit="출석 현황">
                </tit-primary>

                <service-program-card v-bind="{ program }" hideApplyButton />
            </v-container>
        </section>

        <section class="section--sm section--last">
            <v-container>
                <h4 class="tit--sm mb-16 mb-lg-34">행사일정</h4>
                <service-program-attendances v-bind="{ program }" />
                <div class="board-buttons d-flex justify-end mt-20 mt-lg-30">
                    <v-btn @click="$router.go(-1)" small outlined color="grey" class="h-lg-40px"><span class="color-grey">List</span></v-btn>
                </div>
            </v-container>
        </section>

        <!-- <main class="main" role="main">
            <div class="inner">
                <div class="mypage-title"><h1 class="text">마이페이지</h1></div>
                <div class="mypage-container"> 
                    <mypage-navigation />
                    <div class="mypage-contents">
                        <service-program-card v-bind="{ program }" hideApplyButton />

                        <div class="tit-wrap--dot mb-0"><h2 class="tit">행사일정</h2></div>
                        <v-divider class="my-14 my-md-24" />
                        <service-program-attendances v-bind="{ program }" />

                        <div class="mt-12 mt-md-22">
                            <v-row justify="end" class="row--x-small">
                                <v-col cols="auto">
                                    <v-btn outlined color="grey-d6" class="w-140px" @click="$router.go(-1)">목록</v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
            </div>
        </main> -->
    </client-page>
</template>

<script>
import api from "@/api";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
// import MypageNavigation from "@/components/client/mypage-navigation.vue";
import ServiceProgramCard from "@/components/client/service/service-program-card.vue";
import ServiceProgramAttendances from "@/components/client/service/service-program-attendances.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        TitPrimary,
        // MypageNavigation,
        ServiceProgramCard,
        ServiceProgramAttendances,
    },
    props: {
        _program: { type: String, default: null },
    },
    data() {
        return {
            program: null,
        };
    },
    mounted() {
        this.reroute().then(this.init);
    },
    methods: {
        async reroute() {
            if (!this.$store.state.accessToken) this.$router.push("/login");
        },
        async init() {
            let { program } = await api.v1.programs.get({ _id: this._program });
            this.program = program;
        },
    },
};
</script>
